import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
} from "react";
import Input from "../../src/Resources/Forms/Input";
import "../Styles/Pages/pageTop.scss";
import withScreenType from "../HOC/withSceenType";

function PageTop(props) {
  const [searchValue, setSearchValue] = useState("");
  const [showSearchBox, setShowSearchBox] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(
    props.activeTabIndex || 0
  );
  const isMounted = useRef(null);
  const searchBoxRef = useRef();

  useLayoutEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
    } else {
      props.onSearch
        ? props.onSearch(searchValue)
        : props.openedSearch(searchValue);
    }
  }, [searchValue]);

  const openSearchBoxOrFilter = (field) => {
    if (field === "filter" && props.showFilter) return props.showFilter();
    else return setShowSearchBox(true);
  };

  const closeBtn = (field) => {
    if (field === "search") {
      setSearchValue("");
      props.onSearch && props.onSearch("");
      return setShowSearchBox(false);
    }
    return console.log("Leaving Filter");
  };

  useEffect(() => {
    if (showSearchBox && searchBoxRef.current) {
      return searchBoxRef.current.focus();
    }
  }, [showSearchBox]);

  function onTabClick(index) {
    if (props.onTabChange) {
      setActiveTabIndex(index);
      props.onTabChange(index);
    }
  }

  return (
    <div className="page-top">
      <div className="page-top-header">
        <div
          className={`page-top-header-summary ${
            props.isTab ? "page-top-header-summary-tabs" : ""
          }`}
        >
          {!props.summary
            ? []
            : props.summary.map((item, index) => (
                <div
                  className={`page-top-header-summary-each ${
                    (props.isTab && activeTabIndex === index) ||
                    props.activeTabIndex === index
                      ? "active-tab"
                      : ""
                  } ${props.summary.length > 3 ? "summary-length" : ""}`}
                  key={index}
                  onClick={() => onTabClick(index)}
                >
                  <div
                    className="panel"
                    style={{ cursor: props.isTab ? "pointer" : "" }}
                  >
                    <div className="page-top-name">{item.text}</div>
                    {props.showLoader ? (
                      <span className="loading-circle loading-circle-small"></span>
                    ) : (
                      <div
                        className="page-top-count"
                        style={{ fontWeight: props.isLightValue ? 400 : "" }}
                      >
                        {item.value || 0}
                      </div>
                    )}
                  </div>
                </div>
              ))}
        </div>
        <div className="page-top-header-filter">
          {props.screenType === "mobile" ? (
            <Fragment>
              <div className="page-top-search">
                {!props.onSearch && !props.openedSearch ? (
                  <>
                    {props.showFilter && (
                      <div
                        className={`page-top-search-filter page-top-btn`}
                        role="button"
                        onClick={() => openSearchBoxOrFilter("filter")}
                      >
                        {/* <img src='Images/sort.svg' alt='' /> */}
                        <span className="">Filter</span>
                        <span>
                          <img src="Images/sort.svg" alt="" />
                        </span>
                      </div>
                    )}
                  </>
                ) : (
                  <Fragment>
                    {!props.hideFilterSearch && (
                      <div className="flex">
                        <div className="relative" style={{ width: "100%", marginTop: "20px" }}>
                          <Input
                            placeholder={"Search"}
                            onChange={(e) => setSearchValue(e.target.value)}
                            // value={props.value}
                            maxLength={30}
                            // ref
                          />
                          <div
                            className={`page-top-search-filter page-top-sm`}
                            role="button"
                            onClick={() => openSearchBoxOrFilter("filter")}
                          >
                            {/* <img src='Images/sort.svg' alt='' /> */}
                            <span className=""></span>
                            <span>
                              <img src="Images/sort.svg" alt="" />
                            </span>
                          </div>
                        </div>
                        {props.onExportClick && (
                          <span
                            onClick={() => props.onExportClick()}
                            className="flex align-center mobile-export"
                          >
                            {props.isExporting ? (
                              <span className="loading-circle loading-circle-small" />
                            ) : (
                              <img
                                style={{
                                  height: "16px",
                                  width: "16px",
                                }}
                                src="Images/download-icon-1.svg"
                                alt=""
                                title="download"
                              />
                            )}
                          </span>
                        )}
                      </div>
                    )}
                  </Fragment>
                )}
              </div>
            </Fragment>
          ) : (
            <Fragment>
              {!showSearchBox ? (
                <Fragment>
                  {props.onExportClick && (
                    <div
                      className="page-top-btn"
                      role="button"
                      onClick={() => props.onExportClick()}
                    >
                      {props.isExporting ? (
                        <span
                          className="loading-circle loading-circle-small"
                          style={{ margin: "2px 4px 2px 0px" }}
                        />
                      ) : (
                        <span>
                          <img
                            src="Images/download-icon-1.svg"
                            alt=""
                            style={{ opacity: 1 }}
                          />
                        </span>
                      )}
                      <span className="show--desktop">
                        {props.onExportText || "Export"}
                      </span>
                    </div>
                  )}
                  {props.showFilter && (
                    <div
                      className="page-top-btn"
                      role="button"
                      onClick={() => openSearchBoxOrFilter("filter")}
                    >
                      <span>
                        <img src="Images/sort.svg" alt="" />
                      </span>
                      <span className="show--desktop">Filter</span>
                      {props.filterCount > 0 && (
                        <p className="filter-count">{props.filterCount}</p>
                      )}
                    </div>
                  )}
                  {props.onSearch && (
                    <div
                      className="page-top-btn"
                      role="button"
                      onClick={() => openSearchBoxOrFilter("search")}
                    >
                      <span>
                        <img src="Images/new-search.svg" alt="" />
                      </span>
                      <span className="show--desktop">Search</span>
                    </div>
                  )}
                  {props.openedSearch && (
                    <div className="page-top-search" style={{ width: "45%" }}>
                      <Input
                        // value={props.value}
                        placeholder={"Search"}
                        onChange={(e) => setSearchValue(e.target.value)}
                        maxLength={30}
                      />
                    </div>
                  )}
                </Fragment>
              ) : (
                <Fragment>
                  <div className="page-top-search" style={{ width: "45%" }}>
                    <Input
                      width={props.width}
                      value={props.value}
                      placeholder={"Search"}
                      onChange={(e) => setSearchValue(e.target.value)}
                      maxLength={30}
                      ref={searchBoxRef}
                    />
                    <div
                      className="page-top-search-close"
                      style={{ right: props.isPayLater ? "-70px" : "" }}
                      // ^^ to make sure the x renders properly for paylater search bar
                      onClick={() => closeBtn("search")}
                    >
                      &times;
                    </div>
                  </div>
                </Fragment>
              )}
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
}

export default withScreenType(PageTop);
